// extracted by mini-css-extract-plugin
export var highlightFade = "_1v-4";
export var highlighted = "_1v-3";
export var table = "_1v-1";
export var tableContainer = "_1v-0";
export var totalsRow = "_1v-2";